module.exports = __webpack_public_path__ + "img/image5.4023f204.png";